import { MachineData } from '../types/types'
export const machineData: MachineData[] = [
  {
    id: 'ausbeulanlage-1',
    name: 'Ausbeulanlage',
    type: 'ausbeulanlage',
    status: 'operational',
    metrics: {
      efficiency: 87,
      operatingHours: 1243,
      warnings: 2,
      temperature: 42,
      currentLoad: 78,
    },
    components: [
      {
        id: 'comp-1',
        name: 'Hydraulikpumpe',
        status: 'optimal',
        lastMaintenance: '15.04.2023',
        operatingHours: 420,
        performance: 92,
      },
      {
        id: 'comp-2',
        name: 'Drucksensor',
        status: 'warning',
        lastMaintenance: '03.02.2023',
        operatingHours: 1100,
        performance: 68,
      },
      {
        id: 'comp-3',
        name: 'Steuerungseinheit',
        status: 'optimal',
        lastMaintenance: '22.05.2023',
        operatingHours: 380,
        performance: 95,
      },
    ],
    workSteps: [
      {
        name: 'Vorbereitungsphase',
        description: 'Einrichtung und Kalibrierung der Ausbeulwerkzeuge',
        completed: true,
      },
      {
        name: 'Detektion',
        description: 'Erkennung und Vermessung der Dellen',
        completed: true,
      },
      {
        name: 'Ausbeulprozess',
        description: 'Automatische Korrektur der Dellen',
        completed: false,
      },
      {
        name: 'Qualitätskontrolle',
        description: 'Überprüfung des Ergebnisses',
        completed: false,
      },
    ],
    performanceHistory: [
      { time: '00:00', value: 65 },
      { time: '02:00', value: 72 },
      { time: '04:00', value: 80 },
      { time: '06:00', value: 85 },
      { time: '08:00', value: 90 },
      { time: '10:00', value: 88 },
      { time: '12:00', value: 82 },
      { time: '14:00', value: 79 },
      { time: '16:00', value: 75 },
      { time: '18:00', value: 80 },
      { time: '20:00', value: 78 },
      { time: '22:00', value: 70 },
    ],
    logs: [
      {
        timestamp: '22.06.2023 08:15',
        type: 'info',
        component: 'System',
        message: 'Anlage gestartet',
      },
      {
        timestamp: '22.06.2023 10:23',
        type: 'warning',
        component: 'Drucksensor',
        message: 'Druckabfall erkannt - Überprüfung empfohlen',
      },
      {
        timestamp: '22.06.2023 12:45',
        type: 'info',
        component: 'Hydraulikpumpe',
        message: 'Automatische Kalibrierung durchgeführt',
      },
      {
        timestamp: '22.06.2023 14:30',
        type: 'error',
        component: 'Steuerungseinheit',
        message: 'Kommunikationsfehler - Neustart erforderlich',
      },
      {
        timestamp: '22.06.2023 14:35',
        type: 'info',
        component: 'Steuerungseinheit',
        message: 'Neustart erfolgreich',
      },
    ],
    analytics: {
      averageEfficiency: 83,
      totalOperatingHours: 1243,
      errorRate: 1.2,
    },
  },
  {
    id: 'waschanlage-1',
    name: 'Waschanlage',
    type: 'waschanlage',
    status: 'operational',
    metrics: {
      efficiency: 92,
      operatingHours: 2150,
      warnings: 0,
      temperature: 38,
      currentLoad: 85,
    },
    components: [
      {
        id: 'comp-1',
        name: 'Wasserpumpe',
        status: 'optimal',
        lastMaintenance: '10.05.2023',
        operatingHours: 520,
        performance: 95,
      },
      {
        id: 'comp-2',
        name: 'Reinigungsdüsen',
        status: 'optimal',
        lastMaintenance: '10.05.2023',
        operatingHours: 520,
        performance: 90,
      },
      {
        id: 'comp-3',
        name: 'Fördersystem',
        status: 'optimal',
        lastMaintenance: '10.05.2023',
        operatingHours: 520,
        performance: 92,
      },
    ],
    workSteps: [
      {
        name: 'Vorreinigung',
        description: 'Entfernung grober Verschmutzungen',
        completed: true,
      },
      {
        name: 'Hauptwäsche',
        description: 'Intensive Reinigung mit Reinigungsmittel',
        completed: true,
      },
      {
        name: 'Nachspülung',
        description: 'Entfernung von Reinigungsmittelresten',
        completed: true,
      },
      {
        name: 'Trocknung',
        description: 'Trocknung der gereinigten Fässer',
        completed: false,
      },
    ],
    performanceHistory: [
      { time: '00:00', value: 80 },
      { time: '02:00', value: 82 },
      { time: '04:00', value: 85 },
      { time: '06:00', value: 90 },
      { time: '08:00', value: 95 },
      { time: '10:00', value: 92 },
      { time: '12:00', value: 90 },
      { time: '14:00', value: 88 },
      { time: '16:00', value: 92 },
      { time: '18:00', value: 90 },
      { time: '20:00', value: 85 },
      { time: '22:00', value: 82 },
    ],
    logs: [
      {
        timestamp: '22.06.2023 07:30',
        type: 'info',
        component: 'System',
        message: 'Anlage gestartet',
      },
      {
        timestamp: '22.06.2023 09:15',
        type: 'info',
        component: 'Wasserpumpe',
        message: 'Optimaler Betriebsdruck erreicht',
      },
      {
        timestamp: '22.06.2023 12:00',
        type: 'info',
        component: 'Fördersystem',
        message: 'Routinekontrolle durchgeführt',
      },
      {
        timestamp: '22.06.2023 15:45',
        type: 'info',
        component: 'Reinigungsmitteldosierung',
        message: 'Reinigungsmittel nachgefüllt',
      },
    ],
    analytics: {
      averageEfficiency: 90,
      totalOperatingHours: 2150,
      errorRate: 0.3,
    },
  },
  {
    id: 'roboterarm-1',
    name: 'Roboterarm',
    type: 'roboterarm',
    status: 'maintenance',
    metrics: {
      efficiency: 65,
      operatingHours: 3450,
      warnings: 5,
      temperature: 55,
      currentLoad: 40,
    },
    components: [
      {
        id: 'comp-1',
        name: 'Servomotor A',
        status: 'warning',
        lastMaintenance: '02.01.2023',
        operatingHours: 3450,
        performance: 60,
      },
      {
        id: 'comp-2',
        name: 'Servomotor B',
        status: 'critical',
        lastMaintenance: '02.01.2023',
        operatingHours: 3450,
        performance: 45,
      },
      {
        id: 'comp-3',
        name: 'Steuerungssystem',
        status: 'optimal',
        lastMaintenance: '15.05.2023',
        operatingHours: 420,
        performance: 90,
      },
      {
        id: 'comp-4',
        name: 'Greifer',
        status: 'warning',
        lastMaintenance: '02.01.2023',
        operatingHours: 3450,
        performance: 65,
      },
    ],
    workSteps: [
      {
        name: 'Kalibrierung',
        description: 'Positionskalibrierung des Roboterarms',
        completed: true,
      },
      {
        name: 'Materialaufnahme',
        description: 'Aufnahme des zu bearbeitenden Materials',
        completed: false,
      },
      {
        name: 'Bearbeitung',
        description: 'Durchführung der programmierten Arbeitsschritte',
        completed: false,
      },
      {
        name: 'Ablage',
        description: 'Ablage des bearbeiteten Materials',
        completed: false,
      },
    ],
    performanceHistory: [
      { time: '00:00', value: 50 },
      { time: '02:00', value: 55 },
      { time: '04:00', value: 60 },
      { time: '06:00', value: 65 },
      { time: '08:00', value: 70 },
      { time: '10:00', value: 65 },
      { time: '12:00', value: 60 },
      { time: '14:00', value: 55 },
      { time: '16:00', value: 50 },
      { time: '18:00', value: 45 },
      { time: '20:00', value: 40 },
      { time: '22:00', value: 35 },
    ],
    logs: [
      {
        timestamp: '22.06.2023 06:45',
        type: 'warning',
        component: 'Servomotor A',
        message: 'Erhöhte Betriebstemperatur festgestellt',
      },
      {
        timestamp: '22.06.2023 08:30',
        type: 'error',
        component: 'Servomotor B',
        message: 'Überhitzung - Notabschaltung eingeleitet',
      },
      {
        timestamp: '22.06.2023 09:15',
        type: 'info',
        component: 'System',
        message: 'Wartungsmodus aktiviert',
      },
      {
        timestamp: '22.06.2023 11:20',
        type: 'warning',
        component: 'Greifer',
        message: 'Reduzierte Greifkraft festgestellt',
      },
      {
        timestamp: '22.06.2023 14:00',
        type: 'info',
        component: 'Techniker',
        message: 'Wartungsarbeiten begonnen',
      },
    ],
    analytics: {
      averageEfficiency: 72,
      totalOperatingHours: 3450,
      errorRate: 3.8,
    },
  },
  {
    id: 'faesser-buerste-1',
    name: 'Fässer Bürste',
    type: 'faesserBuerste',
    status: 'operational',
    metrics: {
      efficiency: 89,
      operatingHours: 1820,
      warnings: 1,
      temperature: 35,
      currentLoad: 82,
    },
    components: [
      {
        id: 'comp-1',
        name: 'Bürstenantrieb',
        status: 'optimal',
        lastMaintenance: '20.03.2023',
        operatingHours: 680,
        performance: 92,
      },
      {
        id: 'comp-2',
        name: 'Bürstenkopf',
        status: 'warning',
        lastMaintenance: '20.03.2023',
        operatingHours: 680,
        performance: 75,
      },
      {
        id: 'comp-3',
        name: 'Positionierungssystem',
        status: 'optimal',
        lastMaintenance: '20.03.2023',
        operatingHours: 680,
        performance: 90,
      },
    ],
    workSteps: [
      {
        name: 'Positionierung',
        description: 'Ausrichtung des Fasses zur Bürste',
        completed: true,
      },
      {
        name: 'Bürstvorgang',
        description: 'Reinigung der Fassoberfläche',
        completed: true,
      },
      {
        name: 'Inspektion',
        description: 'Überprüfung des Reinigungsergebnisses',
        completed: false,
      },
    ],
    performanceHistory: [
      { time: '00:00', value: 75 },
      { time: '02:00', value: 78 },
      { time: '04:00', value: 82 },
      { time: '06:00', value: 85 },
      { time: '08:00', value: 90 },
      { time: '10:00', value: 92 },
      { time: '12:00', value: 88 },
      { time: '14:00', value: 85 },
      { time: '16:00', value: 82 },
      { time: '18:00', value: 85 },
      { time: '20:00', value: 80 },
      { time: '22:00', value: 75 },
    ],
    logs: [
      {
        timestamp: '22.06.2023 07:00',
        type: 'info',
        component: 'System',
        message: 'Anlage gestartet',
      },
      {
        timestamp: '22.06.2023 09:45',
        type: 'warning',
        component: 'Bürstenkopf',
        message: 'Bürstenabnutzung erkannt - Austausch in Kürze erforderlich',
      },
      {
        timestamp: '22.06.2023 13:30',
        type: 'info',
        component: 'Positionierungssystem',
        message: 'Kalibrierung durchgeführt',
      },
    ],
    analytics: {
      averageEfficiency: 85,
      totalOperatingHours: 1820,
      errorRate: 0.8,
    },
  },
  {
    id: 'sandstrahlmaschine-1',
    name: 'Sandstrahlmaschine für Fässer',
    type: 'sandstrahlmaschine',
    status: 'operational',
    metrics: {
      efficiency: 91,
      operatingHours: 980,
      warnings: 0,
      temperature: 32,
      currentLoad: 88,
    },
    components: [
      {
        id: 'comp-1',
        name: 'Strahlmittelpumpe',
        status: 'optimal',
        lastMaintenance: '05.05.2023',
        operatingHours: 320,
        performance: 95,
      },
      {
        id: 'comp-2',
        name: 'Strahlkabine',
        status: 'optimal',
        lastMaintenance: '05.05.2023',
        operatingHours: 320,
        performance: 90,
      },
      {
        id: 'comp-3',
        name: 'Absauganlage',
        status: 'optimal',
        lastMaintenance: '05.05.2023',
        operatingHours: 320,
        performance: 92,
      },
    ],
    workSteps: [
      {
        name: 'Vorbereitung',
        description: 'Fass in Strahlkabine positionieren',
        completed: true,
      },
      {
        name: 'Strahlprozess',
        description: 'Oberflächenbehandlung durch Sandstrahlen',
        completed: true,
      },
      {
        name: 'Reinigung',
        description: 'Entfernung von Strahlmittelrückständen',
        completed: true,
      },
      {
        name: 'Qualitätskontrolle',
        description: 'Überprüfung der Oberflächenqualität',
        completed: false,
      },
    ],
    performanceHistory: [
      { time: '00:00', value: 85 },
      { time: '02:00', value: 88 },
      { time: '04:00', value: 90 },
      { time: '06:00', value: 92 },
      { time: '08:00', value: 95 },
      { time: '10:00', value: 93 },
      { time: '12:00', value: 90 },
      { time: '14:00', value: 92 },
      { time: '16:00', value: 90 },
      { time: '18:00', value: 88 },
      { time: '20:00', value: 85 },
      { time: '22:00', value: 82 },
    ],
    logs: [
      {
        timestamp: '22.06.2023 07:15',
        type: 'info',
        component: 'System',
        message: 'Anlage gestartet',
      },
      {
        timestamp: '22.06.2023 10:30',
        type: 'info',
        component: 'Strahlmittelpumpe',
        message: 'Optimaler Betriebsdruck erreicht',
      },
      {
        timestamp: '22.06.2023 13:45',
        type: 'info',
        component: 'Absauganlage',
        message: 'Filter gereinigt',
      },
    ],
    analytics: {
      averageEfficiency: 90,
      totalOperatingHours: 980,
      errorRate: 0.2,
    },
  },
  {
    id: 'buerste-maschine-1',
    name: 'Bürste für Fässer Maschine',
    type: 'buersteMaschine',
    status: 'error',
    metrics: {
      efficiency: 45,
      operatingHours: 2750,
      warnings: 8,
      temperature: 65,
      currentLoad: 20,
    },
    components: [
      {
        id: 'comp-1',
        name: 'Bürstenmotor',
        status: 'critical',
        lastMaintenance: '10.11.2022',
        operatingHours: 2750,
        performance: 30,
      },
      {
        id: 'comp-2',
        name: 'Antriebsriemen',
        status: 'critical',
        lastMaintenance: '10.11.2022',
        operatingHours: 2750,
        performance: 25,
      },
      {
        id: 'comp-3',
        name: 'Steuereinheit',
        status: 'warning',
        lastMaintenance: '10.11.2022',
        operatingHours: 2750,
        performance: 60,
      },
    ],
    workSteps: [
      {
        name: 'Systemdiagnose',
        description: 'Überprüfung der Fehlermeldungen',
        completed: true,
      },
      {
        name: 'Fehlerbehebung',
        description: 'Reparatur der defekten Komponenten',
        completed: false,
      },
      {
        name: 'Testlauf',
        description: 'Überprüfung der Funktionalität',
        completed: false,
      },
    ],
    performanceHistory: [
      { time: '00:00', value: 40 },
      { time: '02:00', value: 35 },
      { time: '04:00', value: 30 },
      { time: '06:00', value: 25 },
      { time: '08:00', value: 20 },
      { time: '10:00', value: 15 },
      { time: '12:00', value: 10 },
      { time: '14:00', value: 5 },
      { time: '16:00', value: 0 },
      { time: '18:00', value: 0 },
      { time: '20:00', value: 0 },
      { time: '22:00', value: 0 },
    ],
    logs: [
      {
        timestamp: '22.06.2023 06:30',
        type: 'warning',
        component: 'Bürstenmotor',
        message: 'Erhöhte Vibration festgestellt',
      },
      {
        timestamp: '22.06.2023 07:15',
        type: 'warning',
        component: 'Antriebsriemen',
        message: 'Verschleißerscheinungen erkannt',
      },
      {
        timestamp: '22.06.2023 08:45',
        type: 'error',
        component: 'Bürstenmotor',
        message: 'Kritischer Fehler - Überhitzung',
      },
      {
        timestamp: '22.06.2023 08:50',
        type: 'error',
        component: 'System',
        message: 'Notabschaltung eingeleitet',
      },
      {
        timestamp: '22.06.2023 09:30',
        type: 'info',
        component: 'Techniker',
        message: 'Fehlerdiagnose gestartet',
      },
      {
        timestamp: '22.06.2023 11:15',
        type: 'error',
        component: 'Antriebsriemen',
        message: 'Riemen gerissen - Austausch erforderlich',
      },
    ],
    analytics: {
      averageEfficiency: 60,
      totalOperatingHours: 2750,
      errorRate: 5.2,
    },
  },
  {
    id: 'dichtpruefungsmaschine-1',
    name: 'Dichtprüfungsmaschine für Fässer',
    type: 'dichtpruefungsmaschine',
    status: 'operational',
    metrics: {
      efficiency: 94,
      operatingHours: 1560,
      warnings: 0,
      temperature: 28,
      currentLoad: 75,
    },
    components: [
      {
        id: 'comp-1',
        name: 'Drucksystem',
        status: 'optimal',
        lastMaintenance: '12.04.2023',
        operatingHours: 580,
        performance: 95,
      },
      {
        id: 'comp-2',
        name: 'Sensoren',
        status: 'optimal',
        lastMaintenance: '12.04.2023',
        operatingHours: 580,
        performance: 98,
      },
      {
        id: 'comp-3',
        name: 'Dichtungen',
        status: 'optimal',
        lastMaintenance: '12.04.2023',
        operatingHours: 580,
        performance: 90,
      },
    ],
    workSteps: [
      {
        name: 'Positionierung',
        description: 'Fass in Prüfposition bringen',
        completed: true,
      },
      {
        name: 'Abdichtung',
        description: 'Fass abdichten und Prüfdruck aufbauen',
        completed: true,
      },
      {
        name: 'Druckprüfung',
        description: 'Durchführung des Drucktests',
        completed: true,
      },
      {
        name: 'Auswertung',
        description: 'Analyse der Prüfergebnisse',
        completed: true,
      },
    ],
    performanceHistory: [
      { time: '00:00', value: 90 },
      { time: '02:00', value: 92 },
      { time: '04:00', value: 95 },
      { time: '06:00', value: 96 },
      { time: '08:00', value: 98 },
      { time: '10:00', value: 95 },
      { time: '12:00', value: 93 },
      { time: '14:00', value: 95 },
      { time: '16:00', value: 94 },
      { time: '18:00', value: 92 },
      { time: '20:00', value: 90 },
      { time: '22:00', value: 88 },
    ],
    logs: [
      {
        timestamp: '22.06.2023 07:00',
        type: 'info',
        component: 'System',
        message: 'Anlage gestartet',
      },
      {
        timestamp: '22.06.2023 09:15',
        type: 'info',
        component: 'Drucksystem',
        message: 'Kalibrierung durchgeführt',
      },
      {
        timestamp: '22.06.2023 12:30',
        type: 'info',
        component: 'Sensoren',
        message: 'Selbsttest erfolgreich',
      },
      {
        timestamp: '22.06.2023 15:45',
        type: 'info',
        component: 'System',
        message: '150 Fässer erfolgreich geprüft',
      },
    ],
    analytics: {
      averageEfficiency: 93,
      totalOperatingHours: 1560,
      errorRate: 0.1,
    },
  },
  {
    id: 'trocknung-1',
    name: 'Trocknung für Fässer',
    type: 'trocknung',
    status: 'operational',
    metrics: {
      efficiency: 88,
      operatingHours: 2100,
      warnings: 1,
      temperature: 75,
      currentLoad: 80,
    },
    components: [
      {
        id: 'comp-1',
        name: 'Heizeinheit',
        status: 'optimal',
        lastMaintenance: '25.03.2023',
        operatingHours: 720,
        performance: 90,
      },
      {
        id: 'comp-2',
        name: 'Lüfter',
        status: 'warning',
        lastMaintenance: '25.03.2023',
        operatingHours: 720,
        performance: 75,
      },
      {
        id: 'comp-3',
        name: 'Temperaturregler',
        status: 'optimal',
        lastMaintenance: '25.03.2023',
        operatingHours: 720,
        performance: 92,
      },
    ],
    workSteps: [
      {
        name: 'Vorheizen',
        description: 'Aufheizen der Trocknungskammer',
        completed: true,
      },
      {
        name: 'Beschickung',
        description: 'Einbringen der Fässer in die Kammer',
        completed: true,
      },
      {
        name: 'Trocknungsprozess',
        description: 'Durchführung des Trocknungsvorgangs',
        completed: true,
      },
      {
        name: 'Abkühlung',
        description: 'Kontrollierte Abkühlung der Fässer',
        completed: false,
      },
    ],
    performanceHistory: [
      { time: '00:00', value: 75 },
      { time: '02:00', value: 78 },
      { time: '04:00', value: 82 },
      { time: '06:00', value: 85 },
      { time: '08:00', value: 90 },
      { time: '10:00', value: 88 },
      { time: '12:00', value: 85 },
      { time: '14:00', value: 82 },
      { time: '16:00', value: 85 },
      { time: '18:00', value: 88 },
      { time: '20:00', value: 85 },
      { time: '22:00', value: 80 },
    ],
    logs: [
      {
        timestamp: '22.06.2023 06:45',
        type: 'info',
        component: 'System',
        message: 'Anlage gestartet',
      },
      {
        timestamp: '22.06.2023 07:30',
        type: 'info',
        component: 'Heizeinheit',
        message: 'Betriebstemperatur erreicht',
      },
      {
        timestamp: '22.06.2023 10:15',
        type: 'warning',
        component: 'Lüfter',
        message: 'Reduzierte Leistung festgestellt',
      },
      {
        timestamp: '22.06.2023 14:30',
        type: 'info',
        component: 'Temperaturregler',
        message: 'Automatische Anpassung durchgeführt',
      },
    ],
    analytics: {
      averageEfficiency: 85,
      totalOperatingHours: 2100,
      errorRate: 0.5,
    },
  },
  {
    id: 'signiermaschine-1',
    name: 'Signiermaschine für Fässer',
    type: 'signiermaschine',
    status: 'operational',
    metrics: {
      efficiency: 96,
      operatingHours: 890,
      warnings: 0,
      temperature: 30,
      currentLoad: 65,
    },
    components: [
      {
        id: 'comp-1',
        name: 'Druckkopf',
        status: 'optimal',
        lastMaintenance: '08.05.2023',
        operatingHours: 420,
        performance: 98,
      },
      {
        id: 'comp-2',
        name: 'Farbsystem',
        status: 'optimal',
        lastMaintenance: '08.05.2023',
        operatingHours: 420,
        performance: 95,
      },
      {
        id: 'comp-3',
        name: 'Positionierungssystem',
        status: 'optimal',
        lastMaintenance: '08.05.2023',
        operatingHours: 420,
        performance: 97,
      },
    ],
    workSteps: [
      {
        name: 'Vorbereitung',
        description: 'Einrichtung der Druckparameter',
        completed: true,
      },
      {
        name: 'Positionierung',
        description: 'Ausrichtung des Fasses zur Druckposition',
        completed: true,
      },
      {
        name: 'Signierung',
        description: 'Aufbringen der Kennzeichnung',
        completed: true,
      },
      {
        name: 'Qualitätskontrolle',
        description: 'Überprüfung der Druckqualität',
        completed: true,
      },
    ],
    performanceHistory: [
      { time: '00:00', value: 90 },
      { time: '02:00', value: 92 },
      { time: '04:00', value: 95 },
      { time: '06:00', value: 98 },
      { time: '08:00', value: 96 },
      { time: '10:00', value: 95 },
      { time: '12:00', value: 97 },
      { time: '14:00', value: 98 },
      { time: '16:00', value: 96 },
      { time: '18:00', value: 95 },
      { time: '20:00', value: 93 },
      { time: '22:00', value: 90 },
    ],
    logs: [
      {
        timestamp: '22.06.2023 07:15',
        type: 'info',
        component: 'System',
        message: 'Anlage gestartet',
      },
      {
        timestamp: '22.06.2023 08:30',
        type: 'info',
        component: 'Druckkopf',
        message: 'Druckkopf kalibriert',
      },
      {
        timestamp: '22.06.2023 11:45',
        type: 'info',
        component: 'Farbsystem',
        message: 'Farbvorrat überprüft',
      },
      {
        timestamp: '22.06.2023 15:00',
        type: 'info',
        component: 'System',
        message: '200 Fässer erfolgreich signiert',
      },
    ],
    analytics: {
      averageEfficiency: 95,
      totalOperatingHours: 890,
      errorRate: 0.1,
    },
  },
  {
    id: 'lackieranlage-01',
    name: 'Lackieranlage',
    type: 'lackieranlage',
    status: 'operational',
    metrics: {
      efficiency: 95,
      operatingHours: 2453,
      warnings: 0,
      temperature: 23.5,
      currentLoad: 92,
    },
    components: [
      {
        id: 'comp-1',
        name: 'Sprühsystem',
        status: 'optimal',
        lastMaintenance: '15.11.2023',
        operatingHours: 450,
        performance: 95,
      },
      {
        id: 'comp-2',
        name: 'Farbversorgung',
        status: 'optimal',
        lastMaintenance: '15.11.2023',
        operatingHours: 450,
        performance: 92,
      },
      {
        id: 'comp-3',
        name: 'Luftfilteranlage',
        status: 'optimal',
        lastMaintenance: '15.11.2023',
        operatingHours: 450,
        performance: 94,
      },
    ],
    workSteps: [
      {
        name: 'Vorbereitung',
        description: 'Einrichtung der Lackierparameter',
        completed: true,
      },
      {
        name: 'Lackierung',
        description: 'Automatische Beschichtung der Fässer',
        completed: true,
      },
      {
        name: 'Trocknung',
        description: 'Kontrollierte Trocknung der Lackschicht',
        completed: false,
      },
    ],
    logs: [
      {
        timestamp: '22.11.2023 08:15',
        type: 'info',
        component: 'System',
        message: 'Anlage gestartet',
      },
      {
        timestamp: '22.11.2023 10:30',
        type: 'info',
        component: 'Sprühsystem',
        message: 'Optimale Sprühparameter erreicht',
      },
    ],
    analytics: {
      averageEfficiency: 93,
      totalOperatingHours: 2453,
      errorRate: 0.2,
    },
    temperature: 23.5,
    pressure: 2.1,
    humidity: 45,
    vibration: 0.3,
    productionRate: 92,
    energyConsumption: 68,
    maintenanceStatus: 'Letzte Wartung: vor 12 Tagen',
    alerts: [],
    performanceHistory: [
      { timestamp: '00:00', value: 91 },
      { timestamp: '04:00', value: 93 },
      { timestamp: '08:00', value: 90 },
      { timestamp: '12:00', value: 92 },
      { timestamp: '16:00', value: 91 },
      { timestamp: '20:00', value: 92 },
    ],
    history: [
      {
        date: '2023-11-10',
        productionRate: 91,
        temperature: 23.2,
        pressure: 2.0,
        energyConsumption: 67,
        downtime: 0,
      },
      {
        date: '2023-11-09',
        productionRate: 93,
        temperature: 23.4,
        pressure: 2.1,
        energyConsumption: 68,
        downtime: 0,
      },
      {
        date: '2023-11-08',
        productionRate: 90,
        temperature: 23.6,
        pressure: 2.2,
        energyConsumption: 69,
        downtime: 15,
      },
      {
        date: '2023-11-07',
        productionRate: 92,
        temperature: 23.3,
        pressure: 2.1,
        energyConsumption: 67,
        downtime: 0,
      },
      {
        date: '2023-11-06',
        productionRate: 91,
        temperature: 23.5,
        pressure: 2.0,
        energyConsumption: 68,
        downtime: 0,
      },
    ],
    parameters: {
      lackiertyp: 'Industrielack',
      viskositaet: 'Medium',
      trocknungszeit: 45,
      schichtdicke: 0.12,
      farbmenge: 85,
    },
    description: 'Automatisierte Lackieranlage für die Fassbeschichtung',
  },
  {
    id: 'machine-siebdruck',
    name: 'Siebdruckanlage',
    type: 'siebdruckanlage',
    status: 'operational',
    metrics: {
      efficiency: 87,
      temperature: 24,
      pressure: 4.2,
      currentLoad: 78,
      warnings: 1,
      operatingHours: 2350,
    },
    components: [
      {
        id: 'comp-1',
        name: 'Druckkopf',
        status: 'optimal',
        lastMaintenance: '2023-11-15',
        operatingHours: 580,
        performance: 92,
      },
      {
        id: 'comp-2',
        name: 'Siebeinheit',
        status: 'optimal',
        lastMaintenance: '2023-11-15',
        operatingHours: 580,
        performance: 88,
      },
      {
        id: 'comp-3',
        name: 'Farbversorgung',
        status: 'warning',
        lastMaintenance: '2023-11-15',
        operatingHours: 580,
        performance: 75,
      },
    ],
    workSteps: [
      {
        name: 'Vorbereitung',
        description: 'Einrichtung der Druckparameter',
        completed: true,
      },
      {
        name: 'Druckvorgang',
        description: 'Durchführung des Siebdrucks',
        completed: false,
      },
      {
        name: 'Qualitätskontrolle',
        description: 'Überprüfung des Druckergebnisses',
        completed: false,
      },
    ],
    performanceHistory: [
      { time: '00:00', value: 82 },
      { time: '04:00', value: 85 },
      { time: '08:00', value: 88 },
      { time: '12:00', value: 86 },
      { time: '16:00', value: 84 },
      { time: '20:00', value: 83 },
    ],
    logs: [
      {
        timestamp: '22.11.2023 08:15',
        type: 'info',
        component: 'System',
        message: 'Anlage gestartet',
      },
      {
        timestamp: '22.11.2023 10:30',
        type: 'warning',
        component: 'Farbversorgung',
        message: 'Farbniveau niedrig',
      },
    ],
    analytics: {
      averageEfficiency: 85,
      totalOperatingHours: 2350,
      errorRate: 0.8,
    },
  },
]
